import CONFIG from 'config';
import RCSLoggerFactory from 'rcs_logger';

export const logger = RCSLoggerFactory.init('[GPT]', {
    level: CONFIG.build.env === 'prod' && !location.href.includes('gptLogs=true') ? 'error' : 'debug',
});
